var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notice"},[_c('div',{staticClass:"notice-text"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"notice-action",on:{"click":_vm.onClick}},[_vm._t("action",[_vm._v("刷新")])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }